export default __webpack_public_path__ + "static/media/info_light.b4636f5d.svg";